import { CContainer } from '@coreui/react';
import * as React from 'react';
import { Redirect } from 'react-router';
import { match } from 'react-router-dom';
import { IMenuTab, IMenuTabItem, MenuActionEnum } from '../abstraction';
import { KTabMenu } from '../components';
import { dispatcher, securitySvc } from '../Karma';
import { GenView } from './GenView';

interface ViewParams {
	menu: string;
}

interface IProps {
	match?: match<ViewParams>
}

interface IState {
	menu: IMenuTab[];
	menuLoading: boolean;
	redirectUrl: string;
	startMenu: string;
}

export class Home extends React.Component<IProps, IState> {
	static URL: string = "/Home/";

	public constructor(props: any) {
		super(props);

		let startMenu = "";
		if (this.props.match) {
			if (this.props.match.params) {
				if (this.props.match.params.menu) {
					let code = this.props.match.params.menu;
					startMenu = code;
				}
			}
		}

		this.state = {
			menu: [],
			menuLoading: true,
			redirectUrl: "",
			startMenu: startMenu,
		};

		try {
			if (securitySvc.isAuth()) {
				dispatcher.getMenus(securitySvc.currentUser.codeMenu)
					.then(data => {
						if ((data != null) && (data.length > 0)) {
							this.setState({ menu: data, menuLoading: false });
						}
						else {
							this.setState({ redirectUrl: "/" })
						}
					})
					.catch((err) => {
						this.setState({ menuLoading: true });
						this.setState({ redirectUrl: "/" })
						console.log("Home getMenus error : " + err);
					});
			}
		}
		catch (err) {
			console.debug(err)
		}
	}

	load(id: string): string {
		// Permet de recharger une d�finition de Layouts (widgets de portail)
		// depuis le localStorage
		let ls = null;
		let gls = global.localStorage;
		let currentMenu = id;
		if (gls[currentMenu + "_" + securitySvc.currentUser.login]) {
			try {
				ls = gls.getItem(currentMenu + "_" + securitySvc.currentUser.login);
			} catch (e) {
				return null;
			}
		}
		return (ls);
	}

	save(id:string, value: string) {
		// Permet de sauvegarder une d�finition de Layouts (widgets de portail)
		// dans le localStorage
		let gls = global.localStorage;
		if (gls) {
			let currentMenu = id;
			gls.setItem(
				currentMenu + "_" + securitySvc.currentUser.login,
				value
			);
		}
	}

	//#region Hacks React

	// TODO: Incompatibilit� React 17
	UNSAFE_componentWillUpdate = (nextProps: IProps) => {
		if (nextProps.match.params.menu != this.props.match.params.menu) {
			if (nextProps.match.params.menu != undefined) {
				this.setState({ startMenu : nextProps.match.params.menu });
			}
			else {
				this.setState({ startMenu: "" });
			}
		}
	}

	//#endregion Hacks React

	//#region Ev�nement page 

	onMenuItemClick = (item: IMenuTabItem) => {
		if (item.action == MenuActionEnum.noAction) return;
		
		if (item.target.startsWith("/")) {
			this.setState({ redirectUrl: item.target });
		}
		else {
			if (item.action == MenuActionEnum.link) {
				window.history.pushState("", "", document.location.href);

				if (item.target.startsWith("/")) this.setState({ redirectUrl: item.target });
				else this.setState({ redirectUrl: GenView.URL + "/" + item.target });
			}
		}
	}

	//#endregion 

	//#region Rendering 

	renderMenu = (menutabs: IMenuTab[]) => {
		if (this.state.menu == undefined) return;
		return <KTabMenu
			backupProvider={this}
			imageProvider={dispatcher}
			onMenuClick={this.onMenuItemClick}
			menutabs={this.state.menu}
			menu={this.state.startMenu}/>
		
	}



	render() {

		if (!securitySvc.isAuth()) return <Redirect to="/"></Redirect>
		if (this.state.redirectUrl) return <Redirect to={this.state.redirectUrl} ></Redirect>
		if (this.state.menuLoading) return (<div></div>);

		let contents = this.renderMenu(this.state.menu);

		return (
			<div>
				<div className="Home">
					<CContainer>
						{contents}
					</CContainer>
				</div>
			</div>
		);
	}
	//#endregion 
}
